import React from 'react';
import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux"


const Politique = (props) => {

    return (
        <main className="container">
            <section className="section-prods">
                <h2>Politique de confidentialité</h2>
                <hr />


                <h3>1. Introduction</h3>
                <p>Chez Court Jus, nous nous engageons à protéger la confidentialité et la sécurité de vos informations personnelles.
                    Cette Politique de Confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations personnelles lorsque vous utilisez
                    notre site web <a href="https://Court-Jus.fr">https://Court-Jus.fr</a> ou nos services.</p>

                <h3>2. Collecte des Informations</h3>
                <p>Nous collectons les informations personnelles que vous nous fournissez volontairement, telles que :</p>
                <ul>
                    <li><span style={{ fontSize: "0.8rem" }}>Nom</span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>Prénom</span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>Nom de l'entreprise</span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>Adresse e-mail</span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>Adresse e-mail professionel</span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>Adresse postale</span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>Numéro de téléphone</span></li>
                </ul>
                <div style={{ width: "95%" }}></div>
                <h3>3. Utilisation des Informations</h3>
                <p>Nous utilisons les informations collectées pour :</p>
                <p>Gerer les commandes.</p>

                <h3>4. Divulgation des Informations</h3>
                <p>Nous pouvons divulguer vos informations personnelles à des tiers dans les cas suivants :</p>
                <ul>
                    <li><span style={{ fontSize: "0.8rem" }}>Avec votre consentement</span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>En réponse à une demande légale ou gouvernementale</span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>Pour protéger nos droits, notre propriété ou notre sécurité, ou ceux de nos utilisateurs</span></li>
                </ul>

                <h3>5. Sécurité des Informations</h3>
                <p>Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles pour protéger vos informations personnelles contre l'accès non autorisé, la perte,
                    la destruction ou la divulgation. Cependant, aucune méthode de transmission sur Internet ou de stockage électronique n'est totalement sécurisée.</p>

                <h3>6. Conservation des Informations</h3>
                <p>Nous conservons vos informations personnelles aussi longtemps que nécessaire pour les finalités décrites dans cette Politique de Confidentialité,
                    sauf si une période de conservation plus longue est requise ou autorisée par la loi.</p>

                <h3>7. Vos Droits</h3>
                <p>Vous avez le droit de :</p>
                <ul>
                    <li><span style={{ fontSize: "0.8rem" }}>Accéder à vos informations personnelles</span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>Corriger ou mettre à jour vos informations personnelles</span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>Demander la suppression de vos informations personnelles</span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>Vous opposer au traitement de vos informations personnelles</span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>Limiter le traitement de vos informations personnelles</span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>Porter vos informations personnelles vers un autre service</span></li>
                </ul>
                <p>Pour exercer ces droits, veuillez nous contacter à COURT JUS court.jus.asso@gmail.com <a href="mailto:court.jus.asso@gmail.com">court.jus.asso@gmail.com</a>.</p>

                <h3>8. Modifications de la Politique de Confidentialité</h3>
                <p>Nous pouvons mettre à jour cette Politique de Confidentialité de temps à autre. Nous vous informerons de toute modification importante en publiant une version mise à jour
                    sur notre site web ou en vous envoyant une notification.</p>

                <h3>9. Contact</h3>
                <p>Si vous avez des questions ou des préoccupations concernant cette Politique de Confidentialité, veuillez nous contacter à <a href="mailto:court.jus.asso@gmail.com">court.jus.asso@gmail.com</a>.</p>

            </section>
        </main>
    )
}

export default Politique;